import { Tag, Tooltip } from '@billy/design-system'
import { ReactElement } from 'react'

interface TransactionsTableJournalCodeCellProps {
  journalCode?: string | null
  journalName?: string | null
}

export const TransactionsTableJournalCodeCell = ({
  journalCode,
  journalName,
}: TransactionsTableJournalCodeCellProps): ReactElement | null => {
  if (!journalCode) {
    return null
  }

  const tag = (
    <Tag color="neutral" type="subtle">
      {journalCode}
    </Tag>
  )

  if (!journalName) {
    return tag
  }

  return (
    <Tooltip label={journalName} placement="top">
      {tag}
    </Tooltip>
  )
}
